/**
 * The bearer token, shared between the hand-written `apiGet` wrapper and the
 * generated OpenAPI client (M0-25) so there is exactly one place that knows
 * how to get one — registered once at startup, in `App.tsx`, so call sites
 * never thread tokens around and tests can stub auth without MSAL.
 */
export type TokenProvider = () => Promise<string | null>;

let getAccessToken: TokenProvider = async () => null;

export function setAccessTokenProvider(provider: TokenProvider) {
  getAccessToken = provider;
}

export async function getCurrentAccessToken(): Promise<string | null> {
  return getAccessToken();
}
